import * as React from 'react'

export interface LeftIconProps {
  children: React.ReactNode
}

export const LeftIcon: React.FC<LeftIconProps> = props => {
  return <span className={'mr-2'}>{props.children}</span>
}
